// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_MfF","cls2":"SidebarComments-cls2_xV_ SidebarComments-cls1_MfF"};